import { Box, Typography } from '@mui/material';
import {
  encryptForUrl,
  getOperationalStatusColorById,
  getOperationalStatusIconById,
  getOperationalStatusNameFromId,
} from '../../common/utils';
import localize from '../../common/localize';

export default function OperationalStatusStatistics({
  operationalStatusId,
  operationalStatusValue,
  initialDateForFilter,
  finalDateForFilter,
}) {
  const removeTimeOfDate = (date) => {
    const splittedDate = date.split(' ');
    const split = splittedDate[0].split('-');
    return `${split[1]}/${split[2]}/${split[0]}`;
  };

  const getEventsFilter = () => {
    const filters = [];
    if (operationalStatusId >= 0) {
      filters.push({
        Name: 'OperationalStatus',
        FriendlyName: localize.operational_status,
        FilterValue: { Value: operationalStatusId },
        Value: getOperationalStatusNameFromId(operationalStatusId),
      });
    }

    if (initialDateForFilter && finalDateForFilter) {
      filters.push({
        Name: 'CreationDate',
        FriendlyName: localize.date_range,
        FilterValue: {
          Value: initialDateForFilter,
          AlternateValue: finalDateForFilter,
        },
        Value: `${removeTimeOfDate(initialDateForFilter)} - ${removeTimeOfDate(
          finalDateForFilter
        )}`,
      });
    }

    return JSON.stringify(filters);
  };

  const color = getOperationalStatusColorById(operationalStatusId);

  return (
    <Box
      onClick={() => {
        window.open(`/events?filter=${encryptForUrl(getEventsFilter())}`, '_blank');
      }}
      sx={{
        width: 160,
        minHeight: 120,
        borderRadius: 3,
        cursor: 'pointer',
        background: '#fff',
        border: '1px solid',
        borderColor: 'grey.200',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 0.5,
        py: 2,
        px: 1.5,
        position: 'relative',
        overflow: 'hidden',
        transition: 'all 0.2s ease',
        '&:hover': {
          boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
          transform: 'translateY(-2px)',
        },
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: 4,
          background: color,
          borderRadius: '12px 12px 0 0',
        },
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          backgroundColor: `${color}14`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& .MuiSvgIcon-root': {
            fontSize: 22,
          },
        }}
      >
        {getOperationalStatusIconById(operationalStatusId)}
      </Box>

      <Typography
        sx={{
          fontSize: '1.6rem',
          fontWeight: 700,
          lineHeight: 1.1,
          color,
        }}
      >
        {operationalStatusValue}
      </Typography>

      <Typography
        sx={{
          fontSize: '0.68rem',
          fontWeight: 500,
          color: 'text.secondary',
          textAlign: 'center',
          lineHeight: 1.2,
          mt: 0.25,
        }}
      >
        {getOperationalStatusNameFromId(operationalStatusId)}
      </Typography>
    </Box>
  );
}
